import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase env vars. Verificar .env.local. ' +
      'Apuntar al proyecto dendev-core (lqgnzcihvcspalyzoogi). ' +
      'Schema "core" debe estar expuesto en Settings → API → Exposed Schemas.',
  );
}

/**
 * Cliente Supabase tipado para el schema `core`.
 *
 * Notas:
 * - `db.schema = 'core'` → todas las queries van implícitas al schema core.
 * - Si necesitás leer `public.agent_mgr_*` (legacy, solo lectura),
 *   usá `supabase.schema('public').from(...)` puntualmente.
 * - El schema `core` necesita estar en "Exposed Schemas" (Dashboard →
 *   Settings → API). Si no, las queries devuelven 404.
 * - Después de cualquier migration que toque schema o tipos, regenerar
 *   `src/types/database.types.ts` (hand-written hasta exponer schema).
 */
export const supabase = createClient<Database, 'core'>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
    db: { schema: 'core' },
  },
);
